import { gql } from 'graphql-tag'

import { USER_CARD_USER } from '@/components/Series/Banners/BreakoutSessionBanner/internal/UserCard.hasura'

export const HOST_CARD_SESSION_HOST = gql`
    fragment HostCardSessionHost on session_host {
        user {
            id
            virtual_display_name
            ...UserCardUser
        }
    }

    ${USER_CARD_USER}
`
